import { Component, OnInit, HostListener, inject } from "@angular/core";
import { environment } from "../../../environments/environment";
import { UserService } from "../../services/user.service";
import { AlertService } from "../../services/alert.service";
import { LoaderService } from "../../services/loader.service";
import { CommonService } from "../../services/common.service";
import { BaseHttpInterceptor } from "../../services/Http-Interceptor.service";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MsgConfig } from "../../app.messages";
import { BaseUtils } from "../../utils/base.utils";
import * as moment from "moment";
import * as signalR from '@microsoft/signalr';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CommonWarnorconfirmPopupComponent } from "../../modules/shared/common-warnorconfirm-popup/common-warnorconfirm-popup.component";
import * as wjcCore from "@grapecity/wijmo";
import { PrivMaskGuard } from "../../guards";
import { AccCategoryE, AccountSettings1E, AccountSettingsE } from "../../models";
import { CommonUtil } from "../../utils";
import { HubService } from "../../services/Hub.service";
import { StorageService } from "../../services/storage.service";
import { InterfaceUtils } from "../../utils/interface.util";
import { timer } from "rxjs";
@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styles: [],
  standalone: false
})
export class LoginComponent implements OnInit {
    popupWindow: Window;
    elem: any;
    imgSource: string;
    LoginFrmGrp: FormGroup;
    loggedIn = false;
    excludeColumns: string[] = [
        "token_type",
        "expires_in",
        ".issued",
        ".expires",
        "Privs",
        "SfaxEncryptionVector"
    ];
    pharName: string;
    pharmacyID: number;
    isLoaderPresent: any;
    errorMessage: string;
    isLoggedMultipleUser: boolean = false;
    formSubmitted = false;
    wijimoDistKey: any;
    private connection: signalR.HubConnection;
    TimeOutSession: string;
    loginResp: boolean;
    frmLaunchAppClik: boolean;
    clearCookiesCalled: boolean;
    maxRetries = 5;
    retryCount = 0;
    @HostListener("window:unload", ["$event"])
    unloadBrowser($event: any) {
        if (environment.production) {
            this.closeAfterSessionTimeOut();
            if (this.popupWindow && !this.popupWindow?.closed && !this._userServ.getAccessToken()) {
                this.popupWindow.close();
            }   
        }
    }

    @HostListener("window:beforeunload", ["$event"])
    closeBrowser($event: any) {
    }


    @HostListener('window:storage', ['$event'])
    onStorageChange(ev: StorageEvent) {
        if (!this._userServ.getAccessToken()) {
            this.loggedIn = false;
            this.TimeOutSession = localStorage.getItem("TimeOutSession")
        }
    }
    accountSettingsTabPrivs: any = [];
    accountSettings: any ;
    private _strgSrvc = inject(StorageService);
    _interfaceUtil = inject(InterfaceUtils);

    constructor(
        private _userServ: UserService,
        private _router: Router,
        private _fb: FormBuilder,
        private _commonService: CommonService,
        private _baseUtils: BaseUtils,
        private _actvRoute: ActivatedRoute,
        private loaderService: LoaderService,
        private modalService: NgbModal,
        private _prvMskGrd: PrivMaskGuard,
        private _alertService: AlertService,
        public _commonUtil: CommonUtil,
        public _hubService : HubService,
        public _httpInt: BaseHttpInterceptor
    ) {

        this.LoginFrmGrp = this._fb.group({
            PharmacyId: [null, Validators.required],
            PharmUsername: [null, Validators.required],
            PharmPassword: [null, Validators.required],
            TechUsername: [],
            TechPassword: [],
            UserId: [],
            CatName: [],
            Priv: [],
            Tenant_Id: [],
            logsRequired:[1]
        });
        this._actvRoute.params.subscribe(
            params => {
                this.pharmacyID = +params["pharmacyID"];
                if (this.pharmacyID) {
                    this.LoginFrmGrp.controls.PharmacyId.patchValue(this.pharmacyID);
                }
            }
        );
    }

    ngOnInit() {
        this.elem = document.documentElement;
        this.imgSource = environment.ImageUrl;
        if (this._userServ.getAccessToken()) {
            this.routingAfterLogin();
        }
        this.loaderService
            .getMessage()
            .subscribe(loader =>
                this.isLoaderPresent = loader);
        // this.loaderService.enableSignIn$.subscribe(respLogin => {
        //         this.disableLogin = respLogin
        // })
        this.LoginFrmGrp.get('TechUsername').valueChanges.subscribe((techUserName:string)=>{
           const techPassword = this.LoginFrmGrp.get('TechPassword')
           if(techUserName && techUserName.trim()!=''){
            techPassword.setValidators([Validators.required])
           }
           else{
            techPassword.clearValidators();
           }
           techPassword.updateValueAndValidity();
        })
    }
    
    routingAfterLogin(isFrmLogin: boolean = false, frmLaunchAppClik?:boolean): void {
        this.frmLaunchAppClik = frmLaunchAppClik;
        let timeOut = this._httpInt.checkAndSetTimeout();
        let endURL = "/login";
        const authenticationToken = this._userServ.getAccessToken();
        if (this.popupWindow && !this.popupWindow.closed) {
            this.popupWindow.close();
        }
        //  else {
        if (authenticationToken && !timeOut) {
            endURL = "eprx/dashboard";
            // this.initiateFullScreenMode();
            this.loggedIn = true;
            /*var sessionStorage = window.sessionStorage.getItem("userLogged");
            if(!sessionStorage) {
                this.isLoggedMultipleUser = true;
                this.displayMessage();
            }  else {
                
            } */
            this.openApplicationWindow(isFrmLogin);

        } else {
            this.loggedIn = false;
            this._router.navigate([endURL]);
        }
    // }
    }
    openApplicationWindow(isFrmLogin: boolean = false) {
        if (this.frmLaunchAppClik)
            this._strgSrvc.setSafeLocalStorage("UnloadInitiatedByLaunch", "true");
        this.popupWindow=window.open(window.location.origin + "/#/eprx/dashboard", "ePrimeRx", "fullscreen=yes,resizable=no,directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,top=0,left=0,height="+screen.height+",width="+screen.width);
        if (this.popupWindow) {
            this.popupWindow.moveTo(0, 0);
            this.popupWindow.resizeTo(screen.width, screen.height);
        }
        if(isFrmLogin) {
            localStorage.setItem("IsFromAfterlLogin", isFrmLogin+"");
        } else {
            sessionStorage.setItem("ExpireTime", this._commonService.encryptData(moment().add(15 * 60, 'seconds').toISOString()));
        }
        
    }
    getWijimoAndDWTDWTLicenseKey() {
        this._userServ.getWijimoAndDWTDWTLicenseKey().subscribe({
            next:(resp) => {
            if (resp) {
                this.retryCount = 0;
                this.wijimoDistKey =  resp.find(obj => obj.KeyName === "wijmoDistrKey");
                const Fontawesome =
                 resp.find(obj => obj.KeyName === "FONTAWESOME_NPM_AUTH_TOKEN");
                const licenseDecryptValue = this._commonService.DecryptData(localStorage.getItem('SfaxEncryptionVector'));
                const DistKeyVal = this._commonService.DecryptData(this.wijimoDistKey.KeyValue, false, licenseDecryptValue);
                wjcCore.setLicenseKey(
                    DistKeyVal
                );
                const DWTLicenseKey = resp.find(obj => obj.KeyName === "DWTLicenseKey");
                if (DWTLicenseKey) {
                    localStorage.setItem("DWTLicensekey", DWTLicenseKey.KeyValue);
                }
                environment.FONTAWESOME_NPM_AUTH_TOKEN = Fontawesome;
            }
        }, error:(err) => {
                if ((err.status === 403 || err.status === 401) && this.retryCount < this.maxRetries) {
                    console.warn('403 fetching license key, retrying...' + this.retryCount);
                    this.retryCount++;
                        timer(500).subscribe(() => {
                            this.getWijimoAndDWTDWTLicenseKey();
                        });
                } else {
                    console.error('Error fetching license key:', err);
                }
            }
        });
    }
    login(e?: any) {
        const techUserName = this.LoginFrmGrp.get('TechUsername');
        const techPassword = this.LoginFrmGrp.get('TechPassword');
        if (this.LoginFrmGrp.valid && !this.isLoaderPresent) {
            if (e && (e.which === 13 || e.which === 1)) {
                e.target.blur();
            }
            this._commonService.generateSecureSecretPhrase();
            this.errorMessage = null;
            this._userServ.Login(this.LoginFrmGrp.value).subscribe(
                resp => {
                    if (resp) {
                        if (resp.Privs) {
                            localStorage.setItem("SfaxEncryptionVector" ,this._commonService.encryptData(resp["SfaxEncryptionVector"]));
                            for (const key in resp) {
                                if (
                                    !this.excludeColumns.includes(key) &&
                                    resp.hasOwnProperty(key)
                                ) {
                                    if(key !== 'access_token'){
                                        this.setLocalStorageData(key, resp[key]); // Set other data in local storage
                                    }
                                }
                            }
                            // resp["Privs"] = this._commonService.encryptData(resp["Privs"]);
                            localStorage.setItem("userLogged", "true");
                            localStorage.setItem("Privs", this._commonService.encryptData(resp["Privs"]));
                            sessionStorage.setItem("ExpireTime", this._commonService.encryptData(moment().add(15 * 60, 'seconds').toISOString()));
                            localStorage.setItem("tokenExpiryTime", this._commonService.encryptData(moment().add(resp?.expires_in, 'seconds').toISOString()));
                            this.LoginFrmGrp.reset();
                            this.AddToGroup();
                            if (this.pharmacyID) {
                                this.LoginFrmGrp.controls.PharmacyId.patchValue(this.pharmacyID);
                            }
                            if (this._userServ.getAccessToken()) {
                                this.checkActiveTabId();
                                this.routingAfterLogin(true);
                                this.errorMessage = null;
                            }
                            // open("location", "_self").close();
                            // window.open(
                            //     window.location.href,
                            //     "",
                            //     "directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no"
                            // );
                        } else if (resp.ExceptionMessage === "User not Found") {
                            this.errorMessage = MsgConfig.INVALID_NAME_PASSW;

                            // this._alertService.error(
                            //     MsgConfig.INVALID_NAME_PASSW
                            // );
                        }
                        // if (this._userServ.getAccessToken()) { // commented as the calling of function already there in 224 line
                        //     this.routingAfterLogin(true);
                        // }
                    } else if (resp.ExceptionMessage === "User not Found") {
                        // this._alertService.error(MsgConfig.INdasVALID_NAME_PASSW);
                        this.errorMessage = MsgConfig.INVALID_NAME_PASSW;
                    }
                },
                error => {
                    if (error) {
                        if (error.error && error.error.ExceptionMessage) {
                            if (error.error.ExceptionMessage === "Pharmacist User Locked") {
                                this.errorMessage = MsgConfig.PHARMICIST_ACCOUNT_LOCKED;
                                // this._alertService.error(MsgConfig.PHARMICIST_ACCOUNT_LOCKED);
                            } else if (error.error.ExceptionMessage === "Technician User Locked") {
                                this.errorMessage = MsgConfig.TECHNICIAN_ACCOUNT_LOCKED;

                                // this._alertService.error(MsgConfig.TECHNICIAN_ACCOUNT_LOCKED);
                            } else {
                                this.errorMessage = MsgConfig.INVALID_NAME_PASSW;

                                // this._alertService.error(MsgConfig.INVALID_NAME_PASSW);
                            }
                        } else {
                            this.errorMessage = "Please enter valid credentials.";

                            // this._alertService.error("Please enter valid credentials." );
                        }
                    } else {
                        this.errorMessage = "Please enter valid credentials.";

                        // this._alertService.error("Please enter valid credentials.");
                    }
                }
            );
        } else {
            if (!this.LoginFrmGrp.controls.PharmacyId.valid) {
                // this._alertService.error("Please enter NPI#.");
                this.errorMessage = "Please enter NPI#.";

            } else if ( (this.LoginFrmGrp.controls.PharmUsername.invalid || this.LoginFrmGrp.controls.PharmPassword.invalid ) 
            && !this.isLoaderPresent) {
                // this._alertService.error("Please enter Pharmacist credentials.");
                this.errorMessage = "Please enter Pharmacist credentials.";
             }
             else if(techUserName && !techPassword?.value){
                 this.errorMessage = "Please enter Technician credentials.";
             }
        }
    }

    AddToGroup()
    {   
        let npi = this._userServ.getToken("UniquePharmacyId");
         this._hubService.AddToGroup(npi);
    }

    checkActiveTabId() {
        var accountSettingsTabs = [
            { setting: "PharmacyInfo", activeTabId: "Patient1" , settingData: "TenantSettings"},
            { setting: "Settings", activeTabId: "Patient2", settingData: "PharmacySettings" },
            { setting: "RxSettings", activeTabId: "Patient3", settingData: "RxSettings" },
            // { setting: "PatientSettings", activeTabId: "Patient4", settingData: "PatientSettings" },
            { setting: "ClinicalSettings", activeTabId: "Patient5" , settingData: "ClinicalSettings"},
            { setting: "DrugSettings", activeTabId: "Patient6", settingData: "DrugSettings" },
            { setting: "PriceUpdateSettings", activeTabId: "Patient7" , settingData: "DrugPriceUpdateSettings"},
            { setting: "ErxSettings", activeTabId: "Patient8", settingData: "ERxSettings" },
            { setting: "LabelSettings", activeTabId: "Patient9" , settingData: "LabelSettings"},
            { setting: "MessagingSettings", activeTabId: "Patient10", settingData: "MessagingSettings" },
            { setting: "ControlFileSettings", activeTabId: "Patient11" , settingData: "ControlFileSettings"},
            { setting: "DMSSetings", activeTabId: "Patient12" , settingData: "DmsSettings"},
            { setting: "WorkFlowSettings", activeTabId: "Patient13" , settingData: "WorkFlowSettings"},
            { setting: "ReportSettings", activeTabId: "Patient14"  , settingData: "FaxAndReportsSettings" },
            { setting: "ThreeFourtyBSettings", activeTabId: "Patient16" , settingData: "ThreeFourtyBSettings"},
            { setting: "InventorySettings", activeTabId: "Patient17" , settingData: "InventorySettings"}];
         var privFirstCheck = 0;
         const userPrivs = this._userServ.getUserPrivsFromCookies();
         this.accountSettingsTabPrivs  = [];
      //   var privMaskValue = this._prvMskGrd.getIdentifyPrivValue();
        this.accountSettings = null;
        for(var i=0; i<accountSettingsTabs.length; i++) {
            if(AccountSettingsE[accountSettingsTabs[i]['setting']] && (accountSettingsTabs[i]['setting'] !== 'ClinicalSettings') && this._prvMskGrd.canActivate(AccCategoryE.AccountSettings, AccountSettingsE[accountSettingsTabs[i]['setting']])) {
                if(!privFirstCheck)  {
                    this.accountSettings =  accountSettingsTabs[i]['activeTabId'];
                         this.accountSettingsTabPrivs.push(accountSettingsTabs[i]['settingData']);
                        
                }   
                 else {
                    this.accountSettingsTabPrivs.push(accountSettingsTabs[i]['settingData']);
                }
                privFirstCheck++;
            }  else if((accountSettingsTabs[i]['setting'] === 'ClinicalSettings') && this._prvMskGrd.canActivate(AccCategoryE.AccountSettings1, AccountSettings1E[accountSettingsTabs[i]['setting']])) {
                  "PatientSettings";
                  if(!this.accountSettings)
                    this.accountSettings = accountSettingsTabs[i]['activeTabId'];
                    this.accountSettingsTabPrivs.push(accountSettingsTabs[i]['settingData']);
            } 
        }
        console.log(this.accountSettingsTabPrivs , "this.accountSettingsTabPriv")
        localStorage.removeItem("AccountSettingActiveTab");
        localStorage.removeItem("AccountSettingTabs");
        localStorage.setItem("AccountSettingActiveTab", this._commonService.encryptData((this.accountSettings)));
        if(this.accountSettingsTabPrivs && this.accountSettingsTabPrivs.length){
        localStorage.setItem("AccountSettingTabs", this._commonService.encryptData(this.accountSettingsTabPrivs));
        }
    }

    setCookie(name: string, value: string, secs: number) {
        let expires = "";
        value = this._commonService.encryptData(value);
        if (secs) {
            let date = new Date();
            date.setTime(date.getTime() + secs);
            expires = "; expires=" + date.toUTCString();
        }
        // document.cookie = name + "=" + (value || "") + expires + "; path=/";
        document.cookie = name + "=" + (value || "") + "" + "; path=/;secure" ;
    }

    setLocalStorageData(name: string, value: string) {
        value = this._commonService.encryptData(value);
        localStorage.setItem(name, value);
    }

    initiateFullScreenMode() {
        const id = document.getElementById("clickFullScreenMode");
        if (this.elem) {
            if (this.elem.mozRequestFullScreen) {
                /* Firefox */
                this.elem.mozRequestFullScreen();
            } else if (this.elem.webkitRequestFullscreen) {
                /* Chrome, Safari and Opera */
                this.elem.webkitRequestFullscreen();
            } else if (this.elem.msRequestFullscreen) {
                /* IE/Edge */
                this.elem.msRequestFullscreen();
            }
        }
    }

    keytab(event: any, fg?: any, fc?: string) {
        let isFcValid = true;
        if (fg && fg.controls[fc]) {
            isFcValid = fg.controls[fc].valid;
        }
        this._baseUtils.keytab(event, isFcValid);
    }

    closeAfterSessionTimeOut() {       
        this._hubService.RemoveFromGroup();
        if (this._userServ.getToken("UserId")) {
            this._userServ
            .Logout(this._userServ.getToken("UserId"))
            .subscribe(resp => {
                this.clearCookies();
            }, error => {
                this.clearCookies();
            }, () => {
                this.clearCookies();
            });
        }
        
    }

    clearCookies() {
        if(this.clearCookiesCalled) {
            return;
        }
        this.clearCookiesCalled = true;
        const res = document.cookie;
        const multiple = res.split(";");
        for (let i = 0; i < multiple.length; i++) {
            const key = multiple[i].split("=");
            document.cookie =
                "" +
                key[0] +
                "=; expires= Thu, 21 Aug 1970 20:00:00 UTC; path=/ ";
        }
        if (typeof localStorage === "undefined") return;
        let SfaxEncryptionVector = this._commonService.DecryptData(localStorage.getItem('SfaxEncryptionVector'));
        let printSet = localStorage.getItem("DefaultLabelPrinter")?localStorage.getItem("DefaultLabelPrinter"):null;
        let reportPrint = localStorage.getItem("DefaultReportPrinter")?localStorage.getItem("DefaultReportPrinter"):null;
        let IsImmediateModeKey = localStorage.getItem("ImmediateOrPopMode") ? this._commonService.getDecryptLocalStorage("ImmediateOrPopMode", false, SfaxEncryptionVector): null;
        let guidKey = localStorage.getItem("GUIDEyecon")?this._commonService.getDecryptLocalStorage("GUIDEyecon", false, SfaxEncryptionVector):null;
        let EyeconIP = localStorage.getItem("EyeconIP")?this._commonService.getDecryptLocalStorage("EyeconIP", false, SfaxEncryptionVector):null;
        let popModeAssigned = localStorage.getItem("popModeAssigned") ? this._commonService.getDecryptLocalStorage("popModeAssigned",false,SfaxEncryptionVector): null;
        const storedValue = this._strgSrvc.get("IvrGUIDDetails");
        let ivrGuid = this._commonService.getIvrGUIDDetails(storedValue, SfaxEncryptionVector);
        localStorage.clear();
        if (printSet) {
            localStorage.setItem("DefaultLabelPrinter", printSet);
        }
        if (reportPrint) {
            localStorage.setItem("DefaultReportPrinter", reportPrint);
        }
        this._interfaceUtil.setPillCounterLocalStorage(SfaxEncryptionVector, IsImmediateModeKey, guidKey, EyeconIP, popModeAssigned);
        if(ivrGuid) {
            this._strgSrvc.set("IvrGUIDDetails", ivrGuid);
        }
        sessionStorage.clear();
    }
    ngAfterViewInit() {
        if(document.querySelector('body') && document.querySelector('body').classList)
              document.querySelector('body').classList.add('bg-white');
    }
    ngOnDestroy(): void {
        if(document.querySelector('body') && document.querySelector('body').classList)
             document.querySelector('body').classList.remove('bg-white');
    }
    displayMessage() {
        const modelRef = this.modalService.open(CommonWarnorconfirmPopupComponent, {
            backdrop: false,
            keyboard: false, windowClass: "large--content"
        });
        modelRef.componentInstance.warnMsg = "You are already logged in on this browser, if you wish to login with a different user, please use a different browser.";
        modelRef.componentInstance.okButton = true;
        modelRef.componentInstance.IsPopUpClosed.subscribe((resp: any) => {
            modelRef.close();
        });
    }
}
